import { BreadcrumbsRoute } from "use-react-router-breadcrumbs";
import RouteLinks from "./RouteLinks";

export const breadCrumbRoutes: BreadcrumbsRoute<string>[] = [
    {
        path: RouteLinks.home,
        breadcrumb: null
    },
    {
        path: RouteLinks.service,
        breadcrumb: null
    }
]